import { render } from "./approveSelectshow.vue?vue&type=template&id=37d1908d&scoped=true&ts=true"
import script from "./approveSelectshow.vue?vue&type=script&lang=ts"
export * from "./approveSelectshow.vue?vue&type=script&lang=ts"

import "./approveSelectshow.vue?vue&type=style&index=0&id=37d1908d&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d1908d"]])

export default __exports__